import {randomId} from '../../../helpers';

export default {
    data() {
        return {
            company: {
                privileged: true,
                name: null,
                street: null,
                street_nr: null,
                building: null,
                zip_code: null,
                city: null,
                district: null,
                state: null,
                share_capital: 0,
                cash_payment_quota_percent: 50,
                call_assembly_percent: 10,
                properties: [],
            },
            foundStreets: [],
            foundProperties: [],
            municipalities: {},
            nameChecking: false,
            focusedProperty: null,
        };
    },
    computed: {
        canDeleteProperties() {
            return this.company.properties.length > 1;
        },
        companyType() {
            return this.company.privileged ? 'privileged' : 'normal';
        },
        companyTypeDisabled() {
            return this.company.share_capital < 35000 || this.company.share_capital >= 80000;
        },
        cities() {
            return !_.isEmpty(this.municipalities) ? Object.keys(this.municipalities) : {};
        },
        hasNameWarning() {
            if (!this.nameChecking) {
                return false;
            }
            return this.nameChecking.match || this.nameChecking.gmbh || this.nameChecking.restricted;
        },
        nameWarning() {
            if (!this.hasNameWarning) {
                return '';
            }

            if (this.nameChecking.match) {
                return __('explanations.special_name_usage');
            }

            if (this.nameChecking.gmbh) {
                return __('explanations.gmbh');
            }

            if (this.nameChecking.restricted) {
                return __('explanations.restricted_strings');
            }
        },
    },
    watch: {
        'company.share_capital': function (amount) {
            this.company.privileged = this.company.share_capital < 35000;
        },
        'company.zip_code': function (zip) {
            if (zip && zip.length === 4) {
                this.loadMunicipalities();
            }
        },
        cities(cities) {
            this.company.city = cities.length ? (cities.includes(this.company.city) ? this.company.city : cities[0]) : null;
        },
        'company.city': function (city) {
            if (city && !_.isEmpty(this.municipalities)) {
                const municipality = this.municipalities[city][0];

                this.company.district = municipality.district;
                this.company.state = municipality.state;
            }
        },
        'company.street': function (street) {
            if (street && street.length > 2) {
                this.searchStreets(street);
            } else {
                this.foundStreets = [];
            }
        },
    },
    created() {
        if (!this.company.properties.length) {
            this.addCompanyProperty();
        }
    },
    methods: {
        addCompanyProperty() {
            const propertyId = randomId();

            this.company.properties.push({
                id: propertyId,
                text: null,
                prohibited: false
            });

        },
        propertyRemoveConfirm(propertyId) {
            this.$refs.propertyDeleteModal.open(() => {
                this.removeCompanyProperty(propertyId);
            })
        },
        removeCompanyProperty(propertyId) {
            this.$delete(this.company.properties, propertyId);
        },
        loadMunicipalities() {
            this.clearValidationErrors();
            ajax('GET', 'municipalities/search', {zip_code: this.company.zip_code})
                .then((response) => {
                    this.municipalities = response.data;
                })
                .catch((e) => {
                    this.handleErrors(e.response);
                });
        },
        searchStreets(name) {
            ajax('GET', 'municipalities/streets', {
                municipality: this.company.city,
                name
            })
                .then((response) => {
                    this.foundStreets = response.data;
                })
                .catch((e) => {
                    this.handleErrors(e.response);
                });
        },
        streetSelected(item) {
            this.company.street = item;
        },
        searchProperties(text) {
            if (text.length > 2) {
                ajax('GET', 'properties/search', {
                    text,
                }).then((response) => {
                    this.foundProperties = response.data;
                }).catch((e) => {
                    this.handleErrors(e.response);
                });
            } else {
                this.foundProperties = [];
            }
        },
        propertySelected(text) {
            this.focusedProperty.text = text;
            this.checkProperty(this.focusedProperty);
        },
        checkSpecialNames() {
            this.nameChecking = false;

            ajax('GET', '/company/check-name', {
                search_query: this.company.name
            }).then((response) => {
                this.nameChecking = response.data;
                this.$nextTick(() => {
                    $('[data-toggle="tooltip"]').tooltip();
                });
            }).catch((e) => {
                //this.handleErrors(e.response);
            });
        },
        checkProperty(property) {
            ajax('GET', '/properties/check', {
                search_query: property.text
            }).then((response) => {
                property.prohibited = response.data.prohibited;
            }).catch((e) => {
                //this.handleErrors(e.response);
            });
        }
    }
};
